<div class="flex justify-between content-center">
  <h3 mat-dialog-title>Filter sheet</h3>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p>Select the segments and respondents you want to filter.</p>

  <mat-selection-list>
    @for (segment of segmentLists; track segment.segmentId) {
      <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-checkbox
            [(ngModel)]="segment.checked"
            (change)="toggleSegment(segment)"
            (click)="$event.stopPropagation()"
          >
            <b>{{ segment.segmentName }}</b>
          </mat-checkbox>
        </mat-expansion-panel-header>
        <div class="pl-4">
          @for (
            respondent of segment.respondents;
            track respondent.respondentId
          ) {
            <mat-checkbox
              [(ngModel)]="respondent.checked"
              (change)="updateSegmentChecked(segment)"
            >
              {{ respondent.firstName }} {{ respondent.lastName }} -
              {{ respondent.callDate | date: 'd MMM y, h:mm a' }}
            </mat-checkbox>
          }
        </div>
      </mat-expansion-panel>
    }
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions class="flex gap-2">
  <button
    class="flex-1 primaryColor-border"
    mat-stroked-button
    mat-dialog-close
  >
    Close window
  </button>
  <button class="flex-1" mat-flat-button color="primary" (click)="submit()">
    Confirm
  </button>
</mat-dialog-actions>
